module.exports = __webpack_public_path__ + "modules/statistics-cloud/img/icon-up.png";